module.exports = __webpack_public_path__ + "static/img/success_icon@3x.17408f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/success_icon@3x.png
// module id = //75
// module chunks = 1